import PropTypes from "prop-types";
import { Empty, Spin } from "antd";
import cn from "../../../utilities/tailwind-merge";
import LocationCard from "./LocationCard";

function LocationList({ locations, loading, t, actionItems, onActionClick, actionLoadingId }) {
    if (loading && locations.length === 0) {
        return (
            <div className="flex min-h-[200px] items-center justify-center">
                <Spin />
            </div>
        );
    }

    if (!loading && locations.length === 0) {
        return (
            <div className="py-10">
                <Empty description={t("noLocationsFound")} image={Empty.PRESENTED_IMAGE_SIMPLE} />
            </div>
        );
    }

    return (
        <div className="relative min-h-[120px]">
            {loading && !actionLoadingId ? (
                <div
                    className="absolute inset-0 z-10 flex items-center justify-center rounded-xl bg-white/70"
                    aria-busy="true"
                    aria-live="polite">
                    <Spin />
                </div>
            ) : null}
            <div
                className={cn(
                    "flex flex-col gap-3",
                    loading && !actionLoadingId && "pointer-events-none select-none opacity-50",
                )}
                aria-hidden={loading && !actionLoadingId}>
                {locations.map((location) => (
                    <LocationCard
                        key={location.locationId}
                        location={location}
                        t={t}
                        actionItems={actionItems}
                        onActionClick={onActionClick}
                        menuDisabled={
                            actionLoadingId != null &&
                            String(actionLoadingId) === String(location.locationId)
                        }
                        isActionLoading={
                            actionLoadingId != null &&
                            String(actionLoadingId) === String(location.locationId)
                        }
                    />
                ))}
            </div>
        </div>
    );
}

LocationList.propTypes = {
    locations: PropTypes.arrayOf(PropTypes.object).isRequired,
    loading: PropTypes.bool.isRequired,
    t: PropTypes.func.isRequired,
    actionItems: PropTypes.arrayOf(PropTypes.object).isRequired,
    onActionClick: PropTypes.func.isRequired,
    actionLoadingId: PropTypes.string,
};

export default LocationList;
